export default {
  path: 'units',
  name: 'stocks.units',
  component: () => import('@/views/admin/stocks/units/Index'),
}